import {useMemo} from 'react'
import {useForm} from '../../../common/hooks/useForm'
import {AddCompartmentForm} from '../AddCompartment'

const createCompartmentInitialForm = (compartmentNumber: number): AddCompartmentForm => ({
  locked: true,
  circuitBoardPort: String(compartmentNumber - 1),
  name: String(compartmentNumber),
  productId: '',
})

export const useAddBoxCompartments = () => {
  const formComp1 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(1), []))
  const formComp2 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(2), []))
  const formComp3 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(3), []))
  const formComp4 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(4), []))
  const formComp5 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(5), []))
  const formComp6 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(6), []))
  const formComp7 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(7), []))
  const formComp8 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(8), []))
  const formComp9 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(9), []))
  const formComp10 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(10), []))
  const formComp11 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(11), []))
  const formComp12 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(12), []))
  const formComp13 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(13), []))
  const formComp14 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(14), []))
  const formComp15 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(15), []))
  const formComp16 = useForm<AddCompartmentForm>(useMemo(() => createCompartmentInitialForm(16), []))

  const compartmentForms = [
    formComp1,
    formComp2,
    formComp3,
    formComp4,
    formComp5,
    formComp6,
    formComp7,
    formComp8,
    formComp9,
    formComp10,
    formComp11,
    formComp12,
    formComp13,
    formComp14,
    formComp15,
    formComp16,
  ]

  const resetAllCompartments = () => {
    for (const compartmentForm of compartmentForms) {
      compartmentForm.reset()
    }
  }

  return {compartmentForms, resetAllCompartments}
}
